// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { Table } from 'react-bootstrap';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import Sorter from '../../utils/Sorting/Sorter';
import '../../../styles/containers/Party.css';
import CheckedIcon from '../../utils/CheckedIcon';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { isMobileResolution } from '../../../infrastructure/utils/common';
import PartyAddMemberMobileTable from './PartyAddMemberMobileTable';

const StyledButton = styled.button`
  display: block;
  width: 121px;
  height: 27px;
  text-align: center;
  border-radius: 50px;
  font-size: 12px;

  border: none;
  outline: none;

  @media (max-width: 768px) {
    width: 100px;
  }
`;

const StyleAddGuestButton = styled(StyledButton)`
  background: #289bbe;
  color: #ffffff;

  span {
    margin-right: 3px;
  }
`;

const StyledAddedNote = styled.div`
  position: relative;
  text-align: center;
  color: #60b573;
  font-size: 15px;
  width: 121px;
  svg {
    position: absolute;
    left: 20px;
    top: 3px;

    width: 14px;
    height: 14px;
    fill: #60b573;
  }
`;

const PartyAddMemberTable = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  users,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  activeSort,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onSortClick,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onAddGuestClick,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  members,
}) => {
  if (isMobileResolution()) {
    return (
      <PartyAddMemberMobileTable
        users={users}
        onAddGuestClick={onAddGuestClick}
        members={members}
        StyleAddGuestButton={StyleAddGuestButton}
        StyledAddedNote={StyledAddedNote}
      />
    );
  }

  return (
    <div className='add-member-list'>
      <Table>
        <thead>
          <tr>
            <th className='sortColumn' onClick={() => onSortClick('name')}>
              Name
              <Sorter activeSort={activeSort} name='name' />
            </th>
            <th className='sortColumn' onClick={() => onSortClick('email')}>
              Email
              <Sorter activeSort={activeSort} name='email' />
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          {users.map(user => (
            <tr key={user.id}>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line react/prop-types */}
                {members.some(member => member.memberId === user.id) ? (
                  <StyledAddedNote>
                    <CheckedIcon /> Added
                  </StyledAddedNote>
                ) : (
                  <StyleAddGuestButton onClick={() => onAddGuestClick(user)}>
                    <span>+</span> Add Guest
                  </StyleAddGuestButton>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default React.memo(PartyAddMemberTable);
